/**
 *
 * @module accountClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef AccountClientEndpoint
 * @type {Object}
 *
 * @property {String} createAccount
 * @property {String} getCurrentAccount
 * @property {String} createAccountGrant
 * @property {String} updateAccountAttributes
 * @property {String} createUserProfile
 * @property {String} deleteUserProfile
 * @property {String} getUserProfile
 * @property {String} getUserProfiles
 * @property {String} setActiveUserProfile
 * @property {String} getActiveUserProfile
 * @property {String} updateUserProfile
 *
 */

/**
 *
 * @enum
 * @type {AccountClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createAccount: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getCurrentAccount: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createAccountGrant: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    updateAccountAttributes: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createUserProfile: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    deleteUserProfile: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getUserProfile: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getUserProfiles: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    setActiveUserProfile: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getActiveUserProfile: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    updateUserProfile: null
});



// WEBPACK FOOTER //
// ./src/services/account/accountClientEndpoint.js